import { red } from '@mui/material/colors';
import { createTheme, getContrastRatio } from '@mui/material/styles';

export const primary = '#20BF55';
export const secondary = '#FFAA00';
export const gray = '#CAC9C9';

// A custom theme for this app
const theme = createTheme({
  palette: {
    primary: {
      main: primary,
      contrastText: getContrastRatio(primary, '#fff') >= 1 ? '#fff' : '#000',
    },
    secondary: {
      main: secondary,
    },
    error: {
      main: red['500'],
    }
  },
});

export default theme;
